import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class Boundary extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.boundary',
        group: 'Spatial Constructors',
        title: 'ST Boundary',
        description: `
      This component adds a new column with the boundary of the input geography.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`SELECT ST_BOUNDARY(${params.geo}) AS ${params.geo}_boundary, *
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40, ${params.geo}_boundary) */
                  SEDONA_ST_ASBINARY(SEDONA_ST_BOUNDARY(SEDONA_ST_GEOMFROMWKB(${params.geo})))
                    AS ${params.geo}_boundary, *
                FROM ${params.source}`
      case Provider.Oracle:
        return dedent`SELECT SDO_GEOM.SDO_BOUNDARY(${params.geo}, 0.005) AS ${params.geo}_boundary, *
                FROM ${connection.quoteName(params.source as string)}`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params, connection }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_boundary`,
      type: connection.getGeoDataType()
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.DatabricksRest, Provider.Oracle]
  }
}

export { Boundary }
